import ApiClient from './ApiClient';

// QM §4.7.2, §4.9, §4.13 Conversation-scoped actions.
// Routes: /accounts/:id/conversations/:conversationId/queue_actions/:action
class QueueActionsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  actionUrl(conversationId, action) {
    return `${this.url}/${conversationId}/queue_actions/${action}`;
  }

  // QM §5.6.4 — routing history of a single ticket for the activity timeline.
  activity(conversationId) {
    return axios.get(this.actionUrl(conversationId, 'activity'));
  }

  // Browse-and-pick self-take of a specific ticket.
  take(conversationId) {
    return axios.post(this.actionUrl(conversationId, 'take'));
  }

  lock(conversationId) {
    return axios.post(this.actionUrl(conversationId, 'lock'));
  }

  unlock(conversationId) {
    return axios.post(this.actionUrl(conversationId, 'unlock'));
  }

  returnToQueue(conversationId) {
    return axios.post(this.actionUrl(conversationId, 'return_to_queue'));
  }

  // QM §4.9 — supervisor moves a waiting ticket to another queue. `overrideLock`
  // releases an existing lock instead of being refused with 422.
  changeQueue(conversationId, queueId, overrideLock = false) {
    return axios.post(this.actionUrl(conversationId, 'change_queue'), {
      queue_id: queueId,
      override_lock: overrideLock,
    });
  }
}

export default new QueueActionsAPI();
